import React from 'react';
// Pilot disabled: checkout navigation is retained for post-pilot restore.
// import { useNavigate } from 'react-router-dom';
import Modal from '../../../components/ui/Modal';
import Icon from '../../../components/AppIcon';

const InsufficientCoinsModal = ({ isOpen, onClose, requiredCoins, currentBalance }) => {
    // Pilot disabled: restore checkout CTA when coin purchases return.
    // const navigate = useNavigate();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            hideHeader={true}
            size="md"
            className="overflow-hidden relative"
        >
            {/* Background Decorative Blurs */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-400/20 rounded-full blur-3xl -mr-16 -mt-16" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-emerald-300/10 rounded-full blur-2xl -ml-12 -mb-12" />

            <div className="flex flex-col items-center text-center p-4 relative z-10">
                {/* Close Button */}
                <button 
                    onClick={onClose}
                    className="absolute top-0 right-0 p-2 text-slate-400 hover:text-slate-600 transition-colors"
                >
                    <Icon name="X" size={20} />
                </button>

                {/* Icon with Glassmorphism Halo */}
                <div className="relative mb-6">
                    <div className="absolute inset-0 bg-emerald-400/20 rounded-full blur-xl scale-150 animate-pulse" />
                    <div className="relative w-20 h-20 rounded-3xl bg-white/40 backdrop-blur-md border border-white/60 shadow-xl flex items-center justify-center rotate-3 group-hover:rotate-0 transition-transform duration-500">
                        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-400 to-green-600 flex items-center justify-center shadow-lg shadow-emerald-200/60">
                            <Icon name="Zap" size={32} color="#FFFFFF" className="fill-white" />
                        </div>
                    </div>
                    {/* Floating mini-coins */}
                    <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-white shadow-md flex items-center justify-center animate-bounce delay-75">
                        <Icon name="Coins" size={16} className="text-emerald-500" />
                    </div>
                </div>

                <h3 className="text-xl font-semibold text-slate-900 mb-2 tracking-tight">Pilot Balance Needed</h3>
                
                <div className="bg-slate-50/50 backdrop-blur-sm border border-slate-200/50 rounded-2xl p-4 mb-8 w-full">
                    <p className="text-slate-600 text-sm leading-relaxed">
                        This pilot interview requires <span className="font-normal text-slate-900">{requiredCoins} coins</span>.
                    </p>
                    <div className="flex items-center justify-center gap-2 mt-2">
                        <span className="text-[10px] font-normal text-slate-400 tracking-wider">Current Balance:</span>
                        <div className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-normal border border-emerald-200">
                            {currentBalance || 0} Coins
                        </div>
                    </div>
                </div>

                {/* Benefits/Value Prop */}
                {/* <div className="grid grid-cols-2 gap-3 mb-8 w-full">
                    {[
                        { icon: 'Cpu', text: 'AI Feedback' },
                        { icon: 'Shield', text: 'Verified Report' },
                    ].map((item, idx) => (
                        <div key={idx} className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white border border-slate-100 shadow-sm">
                            <Icon name={item.icon} size={14} className="text-amber-500" />
                            <span className="text-[11px] font-normal text-slate-600 tracking-wide">{item.text}</span>
                        </div>
                    ))}
                </div> */}

                <div className="flex flex-col w-full gap-3">
                    {/* Pilot disabled: checkout purchase CTA hidden during restricted pilot.
                    <button
                        onClick={() => navigate('/checkout')}
                        className="w-full py-4 bg-slate-900 hover:bg-slate-800 text-white font-normal rounded-2xl transition-all shadow-xl hover:shadow-2xl active:scale-[0.98] flex items-center justify-center gap-2 group"
                    >
                        <Icon name="CreditCard" size={18} />
                        Get More Coins
                        <Icon name="ArrowRight" size={16} className="group-hover:translate-x-1 transition-transform" />
                    </button>
                    */}
                    <div className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-normal leading-relaxed text-slate-600">
                        Coin purchases are disabled for this pilot. Use an assigned test account with a pilot balance.
                    </div>
                    <button
                        onClick={onClose}
                        className="w-full py-3 text-slate-400 hover:text-slate-600 text-sm font-normal transition-colors"
                    >
                        Maybe Later
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InsufficientCoinsModal;
